function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "photoshop",
  d: "M0,0v512h512V0H0z M482,482H30V30h452V482z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "photoshop",
  d: "M174,294.9h40.3c29.5,0,53-25.7,53-56.6c0-26.2-21.2-56.6-54.2-56.6h-72.2V352H174V294.9z M174,210.6h37 c14.1,0,22.8,13.2,22.8,27.6c0,16.8-9.7,27.6-21.4,27.6H174V210.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "photoshop",
  d: "M334.1,331.4c-18.8,0-36.5-11.1-44.2-16.6l-12,20.2c7.2,6.2,27.9,19.4,56.9,19.4c15.7,0,50.9-4.9,50.9-39.8 c0-29.6-40.1-35.7-48.7-37.9c-4.6-1.1-24.7-4.4-24.7-15.8c0-9.2,7.5-14.2,19.2-14.2c15.8,0,30.1,9.1,36.5,13.9l13-19.4 c-6.9-6.1-21.6-17.3-49.2-17.3c-26.3,0-49.4,14.9-49.4,41.5c0,27.6,36.7,32.8,44.9,35c9.8,2.7,27.6,6.2,27.6,17 C354.7,326.3,346.3,331.4,334.1,331.4z"
});

function SvgPhotoshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.939091dc.svg";
export { ForwardRef as ReactComponent };